import React from 'react';
import useInView from '../hooks/useInView';
import { STEPS } from '../data';

const ProcessSection = ({ t }) => {
  const [ref, inView] = useInView(0.1);

  return (
    <section id="process" style={{ padding: '120px 32px', background: t.bg2 }}>
      <div ref={ref} style={{ maxWidth: 1280, margin: '0 auto' }}>
        {/* Header */}
        <div
          style={{
            textAlign: 'center',
            marginBottom: 72,
            opacity: inView ? 1 : 0,
            animation: inView ? 'fadeUp 0.7s cubic-bezier(.16,1,.3,1) forwards' : 'none',
          }}
        >
          <div style={{ fontFamily: "'DM Sans',sans-serif", fontSize: 12, color: t.gold, letterSpacing: 3, textTransform: 'uppercase', marginBottom: 16, fontWeight: 600 }}>
            — Simple Process —
          </div>
          <h2 style={{ fontFamily: "'Cormorant Garamond',serif", fontWeight: 700, fontSize: 'clamp(2.2rem,4vw,3.5rem)', color: t.text, marginBottom: 16 }}>
            Get Your Loan in <span className="gold-text">4 Easy Steps</span>
          </h2>
          <p style={{ fontFamily: "'DM Sans',sans-serif", fontSize: 17, color: t.textSub, maxWidth: 560, margin: '0 auto' }}>
            Our streamlined process ensures you spend less time on paperwork and more time on what matters.
          </p>
        </div>

        {/* Steps */}
        <div style={{ position: 'relative' }}>
          {/* Connecting line (desktop only) */}
          <div
            style={{
              position: 'absolute',
              top: 80, left: '12.5%', right: '12.5%',
              height: 2,
              background: `linear-gradient(90deg,${t.gold},${t.goldLight},${t.gold})`,
              opacity: 0.25,
              zIndex: 0,
            }}
          />
          <div className="four-col" style={{ display: 'grid', gridTemplateColumns: 'repeat(4,1fr)', gap: 24, position: 'relative', zIndex: 1 }}>
            {STEPS.map((step, i) => (
              <div
                key={step.no}
                style={{
                  textAlign: 'center',
                  opacity: inView ? 1 : 0,
                  animation: inView ? `fadeUp 0.6s ${0.12 * i}s cubic-bezier(.16,1,.3,1) forwards` : 'none',
                }}
              >
                {/* Step image with number overlay */}
                <div style={{ position: 'relative', marginBottom: 24, borderRadius: 16, overflow: 'hidden', height: 160 }}>
                  <img src={step.img} alt={step.title} style={{ width: '100%', height: '100%', objectFit: 'cover' }} />
                  <div style={{ position: 'absolute', inset: 0, background: 'linear-gradient(to top,rgba(0,0,0,0.55),transparent)' }} />
                  <div
                    style={{
                      position: 'absolute', top: '50%', left: '50%',
                      transform: 'translate(-50%,-50%)',
                      width: 62, height: 62, borderRadius: '50%',
                      background: 'linear-gradient(135deg,#c9a227,#e8c040)',
                      display: 'flex', alignItems: 'center', justifyContent: 'center',
                      fontFamily: "'Cormorant Garamond',serif", fontSize: 22, fontWeight: 700, color: '#0a0a0a',
                      boxShadow: '0 8px 24px rgba(201,162,39,0.5)',
                    }}
                  >
                    {step.no}
                  </div>
                </div>

                <div style={{ fontSize: 26, marginBottom: 10 }}>{step.icon}</div>
                <h3 style={{ fontFamily: "'Cormorant Garamond',serif", fontWeight: 700, fontSize: 20, color: t.text, margin: '0 0 8px' }}>
                  {step.title}
                </h3>
                <p style={{ fontFamily: "'DM Sans',sans-serif", fontSize: 14, color: t.textSub, lineHeight: 1.7, margin: 0 }}>
                  {step.desc}
                </p>
              </div>
            ))}
          </div>
        </div>

        {/* CTA */}
        <div
          style={{
            textAlign: 'center',
            marginTop: 64,
            opacity: inView ? 1 : 0,
            animation: inView ? 'fadeUp 0.6s 0.65s cubic-bezier(.16,1,.3,1) forwards' : 'none',
          }}
        >
          <a
            href="#contact"
            style={{
              display: 'inline-flex', alignItems: 'center', gap: 10,
              background: 'linear-gradient(135deg,#c9a227,#e8c040)',
              color: '#0a0a0a',
              padding: '18px 48px', borderRadius: 10,
              fontFamily: "'DM Sans',sans-serif", fontWeight: 700, fontSize: 17,
              textDecoration: 'none',
              boxShadow: '0 8px 32px rgba(201,162,39,0.45)',
              transition: 'all 0.3s',
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.transform = 'translateY(-3px)';
              e.currentTarget.style.boxShadow = '0 16px 48px rgba(201,162,39,0.6)';
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.transform = '';
              e.currentTarget.style.boxShadow = '0 8px 32px rgba(201,162,39,0.45)';
            }}
          >
            Start Your Application Now →
          </a>
        </div>
      </div>
    </section>
  );
};

export default ProcessSection;
